import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, DATE } from '@const'
import moment from 'moment'
import * as utils from '@utils'

class SystemTimeChip extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'SystemTimeChip')
        }
        this.query()
        this.interval = setInterval(() => this.update(), 1000)
    }

    state = {
        systemTime: moment().unix(),
        differernce: 0
    }

    interval

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    query() {
        utils.apiRequest(
            'get',
            API.SYSTEM_TIME,
            this.state.input,
            (data) => {
                this.setState({
                    differernce: data.unix_time - moment().unix(),
                    systemTime: moment().unix() + (data.unix_time - moment().unix()),
                })
            },
            (_err) => {},
            true
        )
    }

    update() {
        this.setState({
            systemTime: moment().unix() + this.state.differernce,
        })
    }

    render() {
        return (
            <div>
                {this.t('theEasternTimeZone')}:{' ' + utils.unixToDateTime(this.state.systemTime)}
                {' ( GMT' + DATE.CLIENT_UTC_OFFSET + ' )'}
            </div>
        )
    }
}

SystemTimeChip.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
}

const styles = (_theme) => ({})

export default hoc(styles)(SystemTimeChip)
